import { api } from './api'
import { borrowOptInSubjectCodes } from './borrowedPool'
import type { CachedQuestion, CachedQuestionMode } from './offlineDb'

export interface OfflineReadinessFillResponse {
  fill: {
    priority: 'urgent' | 'background'
    mode: CachedQuestionMode
    programme_names: string[]
    source_institutions: string[]
    subjects: { code: string; name: string; count: number }[]
    total_questions: number
    downloaded_at: string
  }
  buckets: Array<{
    subject_code: string
    subject_name: string
    source_institution: string
    cached_at_band: number | null
    questions: CachedQuestion[]
  }>
}

export async function requestOfflineReadinessFill(args: {
  priority: 'urgent' | 'background'
  mode: CachedQuestionMode
  university?: string | null
  activeSubjectCode?: string | null
  subjectCodes?: string[]
  totalLimit?: number
  countPerSubject?: number
  /** Whose borrow opt-ins to send. Omit and nothing is borrowed. */
  studentId?: string | null
}): Promise<OfflineReadinessFillResponse> {
  return api.post<OfflineReadinessFillResponse>('/offline-readiness/fill', {
    priority: args.priority,
    mode: args.mode,
    university: args.university ?? null,
    active_subject_code: args.activeSubjectCode ?? null,
    subject_codes: args.subjectCodes ?? [],
    ...(typeof args.totalLimit === 'number' ? { total_limit: args.totalLimit } : {}),
    ...(typeof args.countPerSubject === 'number' ? { count_per_subject: args.countPerSubject } : {}),
    // Scoped to this student. The opt-in is given on the question page and
    // the fill is triggered from the subject list, so it travels through
    // sessionStorage rather than through every caller's arguments. Without
    // the id it reads as empty, which means a caller that cannot name the
    // student borrows nothing. The server re-checks each code against the
    // student's own pool and ignores any it does not believe.
    borrow_subject_codes: borrowOptInSubjectCodes(args.studentId),
  })
}
